import { ForwardRefRenderFunction, MouseEventHandler, forwardRef } from 'react';
import cn from 'classnames';
import { IconComponent } from '@/components/common/icons/BaseIcon';

interface ConfigurationHandleProps {
  x: number;
  y: number;
  size: number;
  Icon: IconComponent;
  name?: string;
  onClick?: MouseEventHandler;
  disabled?: boolean;
  scaleFactor?: number;
}

export const ConfigurationHandleWithRef: ForwardRefRenderFunction<
  HTMLButtonElement,
  ConfigurationHandleProps
> = ({ x, y, size, Icon, name, onClick, disabled, scaleFactor }, ref) => {
  const adjustRadius = scaleFactor && scaleFactor < 3 ? 0 : 3;
  return (
    <g
      className={`configuration-handles-zoom__handle__${name}`}
      transform={`translate(${x}, ${y})`}
    >
      <rect width={size} height={size} rx={adjustRadius} ry={adjustRadius} />
      <Icon
        width={size}
        height={size}
        className={cn(disabled && 'configuration-handles__action__disabled')}
      />
      <foreignObject width={size} height={size}>
        <button
          ref={ref}
          type="button"
          disabled={disabled}
          className={cn(
            'configuration-handles-zoom__action',
            name && 'configuration-handles-zoom__action__name',
            disabled && 'configuration-handles-zoom__action__disabled'
          )}
          onClick={onClick}
        ></button>
      </foreignObject>
    </g>
  );
};

export const ConfigurationHandle = forwardRef(ConfigurationHandleWithRef);
